import { Outlet } from 'react-router-dom'
import { Logo } from '@/components/brand'
import { useT } from '@/internationalization/i18n'

/**
 * Sign-in, sign-up, invitation acceptance, SSO callback.
 *
 * Two columns on lg+, one on mobile — and the marketing column is the half that
 * disappears, never the form.
 *
 * The right-hand column claims nothing measurable on purpose. A number on a
 * sign-in page is a promise the product has to keep on every meeting, and the
 * two that used to sit here — a language count and a time-to-summary — are
 * both properties of a recording we have not made yet.
 */
export function AuthLayout() {
  const t = useT()
  const points = [
    ['authLayout.point1.title', 'authLayout.point1.detail'],
    ['authLayout.point2.title', 'authLayout.point2.detail'],
    ['authLayout.point3.title', 'authLayout.point3.detail'],
  ]
  return (
    <div className="flex min-h-dvh bg-canvas">
      <div className="flex w-full flex-col justify-center px-5 py-10 sm:px-10 lg:w-1/2">
        <div className="mx-auto w-full max-w-sm">
          <Logo size="lg" className="mb-8" />
          <Outlet />
        </div>
      </div>

      <aside className="hidden w-1/2 flex-col justify-center border-l border-border bg-surface px-12 lg:flex">
        <blockquote className="max-w-md">
          <p className="text-2xl font-semibold leading-snug tracking-tight text-fg">
            {t('authLayout.quote')}
          </p>
          <footer className="mt-6 text-base text-fg-muted">
            {t('authLayout.quoteFooter')}
          </footer>
        </blockquote>
        <dl className="mt-10 max-w-md space-y-5 border-t border-border pt-8">
          {points.map(([titleKey, detailKey]) => (
            <div key={titleKey} className="flex gap-3">
              <span aria-hidden className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-logo-accent" />
              <div>
                <dt className="text-base font-semibold text-fg">{t(titleKey)}</dt>
                <dd className="mt-0.5 text-sm text-fg-muted">{t(detailKey)}</dd>
              </div>
            </div>
          ))}
        </dl>
      </aside>
    </div>
  )
}
